import Memories from '@/pages/memory/Memories';
import InfiniMemory from '@/pages/memory/InfiniMemory';
import { Tabs } from '@/components/ui/tabs';
import { isInfiniMemoryVisible } from '@/config';
import { useSearchParams } from 'react-router-dom';

export default function MemoryCenter() {
  const [searchParams, setSearchParams] = useSearchParams();
  const showInfiniMemory = isInfiniMemoryVisible();
  const requestedTab = searchParams.get('tab');
  const activeTab = showInfiniMemory && requestedTab === 'infini-memory' ? 'infini-memory' : 'mem0';

  const setActiveTab = (tab: string) => {
    const next = new URLSearchParams(searchParams);
    next.set('tab', tab === 'infini-memory' ? 'infini-memory' : 'mem0');
    setSearchParams(next);
  };

  return (
    <div className="min-h-screen bg-muted/20">
      <div className="space-y-6">
        <div className="space-y-6">
          <div>
            <h1 className="text-2xl font-bold text-foreground tracking-tight">记忆库管理</h1>
            <p className="text-sm text-muted-foreground mt-1">管理记忆库资源</p>
          </div>

          <Tabs
            tabs={[
              { id: 'mem0', label: 'mem0' },
              ...(showInfiniMemory ? [{ id: 'infini-memory', label: 'infini-memory' }] : []),
            ]}
            activeTab={activeTab}
            onChange={setActiveTab}
          />

          {activeTab === 'infini-memory' ? <InfiniMemory /> : <Memories embedded />}
        </div>
      </div>
    </div>
  );
}
